import React, {FC} from 'react'

export const ShapeIcon: FC = () => (
    <svg className='canvas-toolbar__icon' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
        <rect x='3' y='3' width='7' height='7'/>
        <circle cx='17.5' cy='6.5' r='3.5'/>
        <polygon points='12 18 19 21 16 14 8 14 5 21 12 18'/>
    </svg>
)
